export const filterSort = (optionA, optionB) => {
	if (optionA.label === 'Todas') return -1;
	if (optionB.label === 'Todas') return 1;
	return optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase());
};
